<template>
  <div class="seasonal-products-component">
    <div class="container-fluid">
      <div class="row seasonal text-center">
        <div class="overlay"></div>
        <div class="col-12 my-auto d-none d-md-block">
          <h2>Check out our Seasonal Products!</h2>
          <p>Shop our bestselling chocolate gifts for your loved ones for any occasion.</p>
          <a href="/products/seasonal" class="btn btn-dutche">Shop Now</a>
        </div>
        <div class="col-12 my-auto d-md-none d-block">
          <h2>Check out our <br> Seasonal Products!</h2>
          <p>Shop our bestselling chocolate gifts for your loved ones for any occasion.</p>
          <a href="/products/seasonal" class="btn btn-dutche">Shop Now</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Seasonal",
}
</script>

<style lang="sass" scoped>
.seasonal-products-component
  margin-top: 8rem
  font-size: 16px

.seasonal
  background-image: url('../../assets/images/home/seasonal.jpg')
  background-size: cover
  background-repeat: no-repeat
  background-position: center center
  height: 12rem
  position: relative

h2
  font-size: 2em
  font-family: "Might Could"

.btn-dutche
  text-transform: uppercase
  border-radius: 0.5rem
  background-color: $dutche-primary-violet
  color: $white
  font-weight: bolder

.overlay
  position: absolute
  width: 100%
  height: 100%
  opacity: 0.75
  background-color: $gray

@media (min-width: 992px)
  .seasonal
    height: 20rem

  h2
    font-size: 3em
    font-family: "Might Could"
    font-weight: bolder

  .btn-dutche
    padding: 1em 2em
    font-weight: bolder

@media (max-width: 767px)
  .seasonal
    height: auto
    min-height: 20rem
    h2
      font-size: 2.5em
  .seasonal-products-component
    margin-top: 8rem
  .btn-dutche
    padding: 0.5rem 1.5rem
    font-size: 1.2em
@media (max-width: 575px)
  .seasonal-products-component
    margin-top: 4rem
</style>
